const getAnalytics = () => {};

const getEventNameWithLanguage = (eventName, language) => {
  return `${eventName}_${language}`;
};

const logEvent = (_, language, eventName, customParameters) => {
  if (!window.gtag) {
    return;
  }
  window.gtag(
    'event',
    getEventNameWithLanguage(eventName, language),
    customParameters,
  );
};

export const track = {
  homeDailyGameButtonClick: (language = 'pt') => {
    logEvent(getAnalytics(), language, 'home_daily_game_button_click');
  },

  homeUnlimitedGameButtonClick: (language = 'pt') => {
    logEvent(getAnalytics(), language, 'home_unlimited_game_button_click');
  },

  homePreviousGamesButtonClick: (language) => {
    logEvent(getAnalytics(), language, 'home_previous_games_button_click');
  },

  gameStart: (game_id, language = 'pt', mode = null) => {
    logEvent(getAnalytics(), language, 'game_start', {
      game_id,
      mode,
    });
  },

  gameAttempt: (game_id, language = 'pt', mode = null) => {
    logEvent(getAnalytics(), language, 'game_attempt', {
      game_id,
      mode,
    });
  },

  gameWin: (game_id, language = 'pt', mode = null) => {
    logEvent(getAnalytics(), language, 'game_win', {
      game_id,
      mode,
    });
  },

  shareResults: (game_id, language = 'pt', mode = null) => {
    logEvent(getAnalytics(), language, 'share_results', {
      game_id,
      mode,
    });
  },

  dailyHelpButtonClick: (language = 'pt') => {
    logEvent(getAnalytics(), language, 'daily_help_button_click');
  },

  backButtonClick: (language = 'pt') => {
    logEvent(getAnalytics(), language, 'back_button_click');
  },

  feedbackButtonClick: (language = 'pt') => {
    logEvent(getAnalytics(), language, 'feedback_button_click');
  },

  topBannerAction: (language = 'pt', bannerId) => {
    logEvent(getAnalytics(), language, 'top_banner_action', {
      banner_id: bannerId,
    });
  },

  topBannerDismiss: (language = 'pt', bannerId) => {
    logEvent(getAnalytics(), language, 'top_banner_dismiss', {
      banner_id: bannerId,
    });
  },
};
